// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"0929257f","344":"d3dbd4f6","366":"8e638469","367":"60e4475c","432":"00f3f36f","453":"64aababc","702":"51b49fe0","735":"d28f7354","869":"f393e82e","931":"4109dc67","953":"26b8e5b2"}[chunkId] + ".chunk.js";
};